import { TYPE_KEY } from "../common/constant";

export const CHANGE_LANGUAGE_ACTION = "CHANGE_LANGUAGE_ACTION";

export const LANGUAGE = "language";

export const initialState = {
  [LANGUAGE]: "de"
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case CHANGE_LANGUAGE_ACTION:
      newState = Object.assign({}, state, {
        [LANGUAGE]: action[LANGUAGE]
      });
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}

/**
 * Change Language Action
 */
export function changeLanguage(language) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: CHANGE_LANGUAGE_ACTION,
      [LANGUAGE]: language
    });
  };
}
